import { Serializer } from 'jsonapi-serializer';
import { CreateUserPayload } from '../interfaces/create-user-payload.interface';
import { UpdateUserPayload } from '../interfaces/update-user-payload.interface';

const createSerializer = new Serializer('User', {
	keyForAttribute: (attr: string) => attr,
	pluralizeType: false,
	attributes: ['can_see_maas_billing', 'company', 'first_name', 'last_name', 'email', 'role'],
});

export function serializeUser(user: CreateUserPayload, forceLocalUser = false) {
	const serialized = createSerializer.serialize(user);
	if (forceLocalUser) {
		serialized.meta = { ...serialized.meta, force_local: true };
	}
	return serialized;
}

export function serializeUpdateUser(user: UpdateUserPayload) {
	const attributes = (Object.keys(user) as (keyof UpdateUserPayload)[]).filter((k) => k !== 'id');
	const serializer = new Serializer('User', {
		id: 'id',
		keyForAttribute: (attr: string) => attr,
		pluralizeType: false,
		attributes,
	});
	return serializer.serialize(user);
}
